import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/Services/common.service';

export class DynamicDialogConfig {
  UserName?: string;
  SeatNumber?: number;
  /** Picture of the item being given away, shown alongside the winner's name. */
  ItemImageUrl?: string;
  /** Name of the webinar being run. */
  WebinarName?: string;
}

interface Spark {
  left: number;
  top: number;
  delay: number;
  size: number;
}

@Component({
    selector: 'app-congratulations-popup',
    templateUrl: './congratulations-popup.component.html',
    styleUrls: ['./congratulations-popup.component.css'],
    standalone: false
})
export class CongratulationsPopupComponent implements OnInit, OnDestroy {
  isMobileView = false;
  /** Flipped on after mount so the entrance animations run from a clean start. */
  revealed = false;
  imageFailed = false;
  readonly sparks: Spark[] = [];

  private subscription: Subscription;
  private revealHandle: ReturnType<typeof setTimeout> | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DynamicDialogConfig,
    private commonService: CommonService,
    private dialogRef: MatDialogRef<CongratulationsPopupComponent>
  ) {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);

    for (let i = 0; i < 14; i++) {
      this.sparks.push({
        left: Math.round(Math.random() * 92) + 4,
        top: Math.round(Math.random() * 88) + 4,
        delay: Math.round(Math.random() * 2600),
        size: 3 + Math.round(Math.random() * 4)
      });
    }
  }

  get displayName(): string {
    const name = (this.data?.UserName || '').trim();
    return name || 'Unknown User';
  }

  ngOnInit(): void {
    this.revealHandle = setTimeout(() => {
      this.revealHandle = null;
      this.revealed = true;
    }, 30);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    if (this.revealHandle != null) {
      clearTimeout(this.revealHandle);
      this.revealHandle = null;
    }
  }

  /** A broken prize image should collapse, not leave a torn-image placeholder. */
  onImageError(): void {
    this.imageFailed = true;
  }

  close(): void {
    this.dialogRef.close();
  }
}
